<template>
  <b-card>
    <b-row>
      <b-col md="6">
        <h3>{{ $route.name }}</h3>
        <!-- breadcrumb -->
        <b-breadcrumb>
          <b-breadcrumb-item
            ><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item
          >
          <b-breadcrumb-item> <router-link to="/accounting/journal">Journal</router-link></b-breadcrumb-item>
          <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
        </b-breadcrumb>
        <!-- end breadcrumb -->
      </b-col>
      <b-col md="6">
        <!-- terserah mau apa -->
      </b-col>
    </b-row>
    <div class="border-bottom"></div>
    <div v-if="isLoading" style="z-index: 1000;">
        <div class="text-center text-primary my-2 h-100">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Loading...</strong>
        </div>
      </div>
      <div v-else>
        <b-row class="mt-3">
          <b-col md="6">
            <b-row>
              <b-col md="2">
                <label class="labels">Number</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="6">
                <p class="font-weight-bold" v-text="model.journalNumberTransaction ? model.journalNumberTransaction : '-'"></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <label class="labels">date</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="6">
                <p v-text="model.journalDate ? new Date(model.journalDate).toLocaleDateString() : '-'"></p>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="2">
                <label class="labels">Note</label>
              </b-col>
              <b-col md="1"></b-col>
              <b-col md="6">
                <p v-text="model.journalNote ? model.journalNote : '-'"></p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="mt-3 mb-3">
          <b-col md="12">
            <div class="table table-responsive">
              <h4>Transaction History</h4>
              <table class="w-75">
                <thead>
                  <tr>
                    <th>Account</th>
                    <th>Description</th>
                    <th>Debit</th>
                    <th>Credit</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in journalData" :key="list.uuid">
                    <td v-text="list.journalAccount.journalAccountName"></td>
                    <td v-text="list.journalTransactionNote !== '' ? list.journalTransactionNote : '-'"></td>
                    <td v-text="list.journalTransactionDebit !== 0 ? formatNumber(list.journalTransactionDebit) : 0"></td>
                    <td v-text="list.journalTransactionCredit !==0 ? formatNumber(list.journalTransactionCredit) : 0"></td>
                  </tr>
                </tbody>    
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6"></b-col>
          <b-col md="5">
             <div class="w-50 d-flex row-cols-2">
               <div>
                <b-form-input readonly :value="model.journalDebitTotal !== null ? formatNumber(model.journalDebitTotal) : 0"></b-form-input>
                <p>Total Debit</p>
               </div>
               <div class="ml-3">
                <b-form-input readonly :value="model.journalCreditTotal !== null ? formatNumber(model.journalCreditTotal) : 0"></b-form-input>
                <p>Total Credit</p>
               </div>
              </div>
              
          </b-col>
        </b-row>
      </div>
       <b-button class="mt-5 mb-4" @click="goBack()" variant="secondary"
        ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
      >
  </b-card>
</template>

<script>
export default {
  name: 'detail-journal',
  components: {},
  data() {
    return {
      isLoading: false,
      apiUrl:{
        journal: window.AppConfig.apiUrl + 'journal'
      },
      model: {
        journalNumberTransaction: "",
        journalNote: "",
        journalDate: "",
        createdAt: "",
        updatedAt: "",
        journalTransaction: [],
        journalDebitTotal: 0,
        journalCreditTotal: 0
      },
      journalData: [],
    }
  },

  mounted(){
    this.getDetail()
  },

  methods: {
    /** ======== GET DETAIL JOURNAL ===== */
    getDetail(){
      this.isLoading = true
      this.$http.get(this.apiUrl.journal + '/' + this.$route.params.uuid).then((response) => {
        console.log('response is:', response);
        this.model.journalNumberTransaction = response.data.journalNumberTransaction
        this.model.journalNote = response.data.journalNote
        this.model.journalDate = response.data.journalDate
        this.model.journalDebitTotal = response.data.journalDebitTotal,
        this.model.journalCreditTotal = response.data.journalCreditTotal
        if(response.data.journalTransaction !== null){
          this.journalData = response.data.journalTransaction;
        }
      }).catch(error => {
        this.$store.dispatch('notification/error', error);
      })
      this.isLoading = false; 
    },

      formatNumber(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },


    goBack(){
      window.goBack(this);
    }
  },
}
</script>